import { ContentfulService } from '../services/contentfulClient';

import EventItemDto from './eventItemDto';
import EventItem from './eventItemEntity';
import NewsCategory from './newsCategoryEntity';
import NewsItemDto from './newsItemDto';
import NewsItem from './newsItemEntity';
import TopicItemDto from './topicItemDto';
import TopicListItemsDto from './topicListItemsDto';

const newsPageTypeId = "newsPage";
const eventItemTypeId = "eventPage";
const newsCategoryTypeId = "newsCategory";
const eventCategoryTypeId = "eventCategory";

const fetchWelcomePageNewsItemsAsync = (query?: object): Promise<NewsItem[]> => {
  const contentfulClient = new ContentfulService();
  
  return contentfulClient.cdaClient.getEntries(Object.assign({
    content_type: newsPageTypeId,
    'fields.publicationDate[lte]': new Date(),
    limit: 3,
    order: '-fields.publicationDate'
  }, query))
  .then(res => res.items)
    .then(mapToNewsItems);
};
const fetchArchivePageNewsItemsAsync = (query?: object): Promise<NewsItemDto> => {
  const contentfulClient = new ContentfulService();
  
  return contentfulClient.cdaClient.getEntries(Object.assign({
    content_type: newsPageTypeId,
    'fields.publicationDate[lte]': new Date(),
    order: '-fields.publicationDate'
  }, query))
  .then(res => res)
    .then(mapToNewsItemsWithMetadate);
};
const fetchArchivePageNewsItemsByCategoryAsync = (categories: string, query?: object): Promise<NewsItemDto> => {
  const contentfulClient = new ContentfulService();
  
  return contentfulClient.cdaClient.getEntries(Object.assign({
    content_type: newsPageTypeId,
    'fields.categories.sys.id[in]': categories,
    'fields.publicationDate[lte]': new Date(),
    order: '-fields.publicationDate'
  }, query))
  .then(res => res)
    .then(mapToNewsItemsWithMetadate);
};
const fetchNewsItemByIdAsync = (id: string): Promise<NewsItem> => {
    const contentfulClient = new ContentfulService();
    
    return contentfulClient.cdaClient.getEntries(Object.assign({
        content_type: newsPageTypeId,
        'fields.friendlyUrl': id
      }, {}))
      .then(res => res.items)
        .then(mapToNewsItems)
    .then(item => item[0])
  };
const fetchEventItemByIdAsync = (id: string): Promise<EventItem> => {
    const contentfulClient = new ContentfulService();
    
    return contentfulClient.cdaClient.getEntries(Object.assign({
        content_type: eventItemTypeId,
        'fields.friendlyUrl': id
      }, {}))
      .then(res => res.items)
        .then(mapToEventItems)
    .then(item => item[0])
  };
  const fetchNewsCategoriesAsync = (query?: object): Promise<NewsCategory[]> => {
    const contentfulClient = new ContentfulService();
    
    return contentfulClient.cdaClient.getEntries(Object.assign({
      content_type: newsCategoryTypeId
    }, query))
    .then(res => res.items)
      .then(mapToNewsCategoryItems);
  };

  const fetchEventCategoriesAsync = (query?: object): Promise<NewsCategory[]> => {
    const contentfulClient = new ContentfulService();
    
    return contentfulClient.cdaClient.getEntries(Object.assign({
      content_type: eventCategoryTypeId
    }, query))
    .then(res => res.items)
      .then(mapToNewsCategoryItems);
  };

  const fetchEventsItemsAsync = (query?: object): Promise<EventItemDto> => {
    const contentfulClient = new ContentfulService();
    
    return contentfulClient.cdaClient.getEntries(Object.assign({
      content_type: eventItemTypeId,
      order: '-fields.eventDate'
    }, query))
    .then(res => res)
      .then(mapToEventItemsWithMetadate);
  };
  const fetchEventItemsByCategoryAsync = (categories: string, query?: object): Promise<EventItemDto> => {
    const contentfulClient = new ContentfulService();
    
    return contentfulClient.cdaClient.getEntries(Object.assign({
      content_type: eventItemTypeId,
      'fields.categories.sys.id[in]': categories,
      'fields.eventDate[lte]': new Date(),
      order: '-fields.eventDate'
    }, query))
    .then(res => res)
      .then(mapToEventItemsWithMetadate);
  };

  const fetchTopicListItemsAsync = (query?: object): Promise<TopicListItemsDto> => {
    const contentfulClient = new ContentfulService();
    
    return contentfulClient.cdaClient.getEntries(Object.assign({
      order: '-sys.updatedAt',
      'sys.contentType.sys.id[in]': eventItemTypeId + "," + newsPageTypeId
    }, query))
    .then(res => res)
      .then(mapToTopicListItemsDtoWithMetadate)
    .catch(handleFetchTopicListItemsError);
  };
  const fetchTopicListItemsByCategoryAsync = (categories: string, query?: object): Promise<TopicListItemsDto> => {

    return fetchEventItemsByCategoryAsync(categories, query)
    .then(eventItemDto => fetchArchivePageNewsItemsByCategoryAsync(categories, query)
    .then(newsItemDto => MapNewsAndEventDtoToTopicListItemsDto(newsItemDto, eventItemDto))
    .catch(handleFetchTopicListItemsError));
  };
  function handleFetchTopicListItemsError(reason: any): TopicListItemsDto  {
    return new TopicListItemsDto();
  }

  const mapToNewsItemsWithMetadate = (newsItemsObject: any): NewsItemDto => {
    const newsItemDto = new NewsItemDto();
    newsItemDto.newsItems = newsItemsObject.items.map(mapToNewsItem);
    newsItemDto.limit = newsItemsObject.limit;
    newsItemDto.skip = newsItemsObject.skip;
    newsItemDto.total = newsItemsObject.total;

    return newsItemDto;
  };

  const mapToEventItemsWithMetadate = (newsItemsObject: any): EventItemDto => {
    const newsItemDto = new EventItemDto();
    newsItemDto.eventItems = newsItemsObject.items.map(mapToEventItem);
    newsItemDto.limit = newsItemsObject.limit;
    newsItemDto.skip = newsItemsObject.skip;
    newsItemDto.total = newsItemsObject.total;

    return newsItemDto;
  };

  const mapToTopicListItemsDtoWithMetadate = (topicItemsObject: any): TopicListItemsDto => {
    const topicListItemsDto = new TopicListItemsDto();
    topicListItemsDto.topicItems = topicItemsObject.items.map(mapToTopicItem);
    topicListItemsDto.limit = topicItemsObject.limit;
    topicListItemsDto.skip = topicItemsObject.skip;
    topicListItemsDto.total = topicItemsObject.total;

    return topicListItemsDto;
  };

const mapToNewsItems = (newsItems: any[]): NewsItem[] => {
  return newsItems.map(mapToNewsItem);
};
const mapToNewsItem = (newsItemToParse: any): NewsItem => {

  const newsItem = new NewsItem();
  newsItem.id = newsItemToParse.fields.friendlyUrl;
  newsItem.title = newsItemToParse.fields.title;
  newsItem.body = newsItemToParse.fields.body;
  newsItem.publicationDate = new Date(newsItemToParse.fields.publicationDate)

  if (newsItemToParse.fields.newsImage) {
    newsItem.newsImage = newsItemToParse.fields.newsImage.fields.file.url;
  }
  if (newsItemToParse.fields.categories) {
    newsItem.categories = newsItemToParse.fields.categories.map(mapToNewsCategory);
  }
  
  return newsItem;
};

const mapToEventItems = (eventItems: any[]): EventItem[] => {
  return eventItems.map(mapToEventItem);
};
const mapToEventItem = (eventItemToParse: any): EventItem => {

  const eventItem = new EventItem();
  eventItem.id = eventItemToParse.fields.friendlyUrl;
  eventItem.title = eventItemToParse.fields.title;
  eventItem.body = eventItemToParse.fields.eventDescriptionBody;
  eventItem.eventDate = new Date(eventItemToParse.fields.eventDate)

  if (eventItemToParse.fields.eventDescriptionImage) {
    eventItem.eventImage = eventItemToParse.fields.eventDescriptionImage.fields.file.url;
  }

  if (eventItemToParse.fields.eventPlace) {
    eventItem.eventPlace.id = eventItemToParse.fields.eventPlace.sys.id;
    eventItem.eventPlace.title = eventItemToParse.fields.eventPlace.fields.eventTitle;
    eventItem.eventPlace.address = eventItemToParse.fields.eventPlace.fields.address;
  }
  
  return eventItem;
};

const mapToTopicItem = (eventItemToParse: any): TopicItemDto => {

  const topicItemDto = new TopicItemDto();
  topicItemDto.id = eventItemToParse.fields.friendlyUrl;
  topicItemDto.title = eventItemToParse.fields.title;
  topicItemDto.type = eventItemToParse.sys.contentType.sys.id;
  
  return topicItemDto;
};
const MapNewsAndEventDtoToTopicListItemsDto = (newsItemDto: NewsItemDto, eventItemDto: EventItemDto): TopicListItemsDto => {
  const topicListItemsDto = new TopicListItemsDto();
  
  if (newsItemDto.total > eventItemDto.total) {
    topicListItemsDto.total = newsItemDto.total;
    topicListItemsDto.skip = newsItemDto.skip;
    topicListItemsDto.limit = newsItemDto.limit;
  } else {
    topicListItemsDto.total = eventItemDto.total;
    topicListItemsDto.skip = eventItemDto.skip;
    topicListItemsDto.limit = eventItemDto.limit;
  }

  newsItemDto.newsItems.forEach(item => {
    const topicItemDto = new TopicItemDto;
    topicItemDto.id = item.id;
    topicItemDto.title = item.title;
    topicItemDto.publicationDate = item.publicationDate;

    topicListItemsDto.topicItems.push(topicItemDto);
  });

  eventItemDto.eventItems.forEach(item => {
    const topicItemDto = new TopicItemDto;
    topicItemDto.id = item.id;
    topicItemDto.title = item.title;
    topicItemDto.publicationDate = item.eventDate;
    topicItemDto.type = eventItemTypeId;

    topicListItemsDto.topicItems.push(topicItemDto);
  });

  topicListItemsDto.topicItems = topicListItemsDto.topicItems.sort((n1,n2) => {
    if (n1.publicationDate > n2.publicationDate) {
        return -1;
    }

    if (n1.publicationDate < n2.publicationDate) {
        return 1;
    }

    return 0;
  });

  return topicListItemsDto;
}
const mapToNewsCategoryItems = (newsCategories: any[]): NewsCategory[] => {
  return newsCategories.map(mapToNewsCategory);
};
const mapToNewsCategory = (newsCategory: any): NewsCategory => {

  const category = new NewsCategory();
  category.id = newsCategory.sys.id;
  category.contentTypeId = newsCategory.sys.contentType.sys.id;
  category.friendlyUrl = newsCategory.fields.friendlyUrl;
  category.title = newsCategory.fields.title;
  
  return category;
};

export const newsContentManager = {
  fetchArchivePageNewsItemsAsync,
  fetchArchivePageNewsItemsByCategoryAsync,
  fetchEventCategoriesAsync,
  fetchEventItemByIdAsync,
  fetchEventItemsByCategoryAsync,
  fetchEventsItemsAsync,
  fetchNewsCategoriesAsync,
  fetchNewsItemByIdAsync,
  fetchTopicListItemsAsync,
  fetchTopicListItemsByCategoryAsync,
  fetchWelcomePageNewsItemsAsync  
};


// WEBPACK FOOTER //
// ./src/api/newsContentManager.ts